import { ComponentType } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { authState } from '../services/auth-state';

export const AuthenticatedRoute = ({
  component: Component,
  ...rest
}: RouteProps & { component: ComponentType }): JSX.Element => (
  <Route
    {...rest}
    render={(props) => {
      const currentLocation = `${props.location.pathname}${props.location.search}${props.location.hash}`;
      return authState.isLoggedIn() ? (
        <Component {...props} />
      ) : (
        <Redirect to={`/login?service_redirect_url=${encodeURIComponent(currentLocation || '/')}`} />
      );
    }}
  />
);

export const UnauthenticatedRoute = ({
  component: Component,
  ...rest
}: RouteProps & { component: ComponentType }): JSX.Element => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return !authState.isLoggedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/', search: props.location.search, hash: props.location.hash }} />
        );
      }}
    />
  );
};
